import { render, staticRenderFns } from "./calendar-facet-title-alignment.vue?vue&type=template&id=696460c3&"
import script from "./calendar-facet-title-alignment.vue?vue&type=script&lang=js&"
export * from "./calendar-facet-title-alignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports